export default "__VITE_ASSET__f78ea176__"